import React from 'react'
import SessionsCmp from './Sessions'
import SessionsApi from '../../api/Sessions'
import useFetchList from '../../elements/Hooks/useFetchList'

const api = new SessionsApi()
export default function SessionsCont() {
  const {fetch, fetching, list} = useFetchList(api.list)
  return <SessionsCmp {...{fetch, fetching, list}} />
}
